import { BASE_PATH as m, BaseAPI as V, operationServerMap as B } from "../base.js";
import { DUMMY_BASE_URL as y, assertParamExists as d, createRequestFunction as v, serializeDataIfNeeded as P, setSearchParams as E, toPathString as g } from "../common.js";
import u from "axios";
var S = function(n) {
  return {
    chainEmployeeBindingDetail: async (o, r = {}) => {
      d("chainEmployeeBindingDetail", "corpUserId", o);
      const l = "/chain/employee-bindings/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(o))), a = new URL(l, y);
      let e;
      n && (e = n.baseOptions);
      const i = {
        method: "GET",
        ...e,
        ...r
      }, c = {};
      E(a, {});
      let t = e && e.headers ? e.headers : {};
      return i.headers = {
        ...c,
        ...t,
        ...r.headers
      }, {
        url: g(a),
        options: i
      };
    },
    chainEmployeeBindingExecuteBatch: async (o, r = {}) => {
      d("chainEmployeeBindingExecuteBatch", "chainEmployeeBatchActionCommand", o);
      const l = new URL("/chain/employee-bindings/batch", y);
      let a;
      n && (a = n.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...r
      }, i = {}, c = {};
      i["Content-Type"] = "application/json", E(l, c);
      let t = a && a.headers ? a.headers : {};
      return e.headers = {
        ...i,
        ...t,
        ...r.headers
      }, e.data = P(o, e, n), {
        url: g(l),
        options: e
      };
    },
    chainEmployeeBindingPage: async (o, r = {}) => {
      d("chainEmployeeBindingPage", "query", o);
      const l = new URL("/chain/employee-bindings/page", y);
      let a;
      n && (a = n.baseOptions);
      const e = {
        method: "GET",
        ...a,
        ...r
      }, i = {}, c = {};
      if (o !== void 0) for (const [s, h] of Object.entries(o)) c[s] = h;
      E(l, c);
      let t = a && a.headers ? a.headers : {};
      return e.headers = {
        ...i,
        ...t,
        ...r.headers
      }, {
        url: g(l),
        options: e
      };
    },
    chainEmployeeBindingPrecheck: async (o, r, l = {}) => {
      d("chainEmployeeBindingPrecheck", "corpUserId", o), d("chainEmployeeBindingPrecheck", "chainEmployeeBindingSaveCommand", r);
      const a = "/chain/employee-bindings/{corpUserId}/precheck".replace("{corpUserId}", encodeURIComponent(String(o))), e = new URL(a, y);
      let i;
      n && (i = n.baseOptions);
      const c = {
        method: "POST",
        ...i,
        ...l
      }, t = {}, s = {};
      t["Content-Type"] = "application/json", E(e, s);
      let h = i && i.headers ? i.headers : {};
      return c.headers = {
        ...t,
        ...h,
        ...l.headers
      }, c.data = P(r, c, n), {
        url: g(e),
        options: c
      };
    },
    chainEmployeeBindingPrecheckBatch: async (o, r = {}) => {
      d("chainEmployeeBindingPrecheckBatch", "chainEmployeeBatchActionCommand", o);
      const l = new URL("/chain/employee-bindings/batch/precheck", y);
      let a;
      n && (a = n.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...r
      }, i = {}, c = {};
      i["Content-Type"] = "application/json", E(l, c);
      let t = a && a.headers ? a.headers : {};
      return e.headers = {
        ...i,
        ...t,
        ...r.headers
      }, e.data = P(o, e, n), {
        url: g(l),
        options: e
      };
    },
    chainEmployeeBindingSave: async (o, r, l = {}) => {
      d("chainEmployeeBindingSave", "corpUserId", o), d("chainEmployeeBindingSave", "chainEmployeeBindingSaveCommand", r);
      const a = "/chain/employee-bindings/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(o))), e = new URL(a, y);
      let i;
      n && (i = n.baseOptions);
      const c = {
        method: "PUT",
        ...i,
        ...l
      }, t = {}, s = {};
      t["Content-Type"] = "application/json", E(e, s);
      let h = i && i.headers ? i.headers : {};
      return c.headers = {
        ...t,
        ...h,
        ...l.headers
      }, c.data = P(r, c, n), {
        url: g(e),
        options: c
      };
    }
  };
}, p = function(n) {
  const o = S(n);
  return {
    async chainEmployeeBindingDetail(r, l) {
      var a, e;
      const i = await o.chainEmployeeBindingDetail(r, l), c = (a = n == null ? void 0 : n.serverIndex) !== null && a !== void 0 ? a : 0, t = (e = B["ChainEmployeeBindingsApi.chainEmployeeBindingDetail"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (s, h) => v(i, u, m, n)(s, t || h);
    },
    async chainEmployeeBindingExecuteBatch(r, l) {
      var a, e;
      const i = await o.chainEmployeeBindingExecuteBatch(r, l), c = (a = n == null ? void 0 : n.serverIndex) !== null && a !== void 0 ? a : 0, t = (e = B["ChainEmployeeBindingsApi.chainEmployeeBindingExecuteBatch"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (s, h) => v(i, u, m, n)(s, t || h);
    },
    async chainEmployeeBindingPage(r, l) {
      var a, e;
      const i = await o.chainEmployeeBindingPage(r, l), c = (a = n == null ? void 0 : n.serverIndex) !== null && a !== void 0 ? a : 0, t = (e = B["ChainEmployeeBindingsApi.chainEmployeeBindingPage"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (s, h) => v(i, u, m, n)(s, t || h);
    },
    async chainEmployeeBindingPrecheck(r, l, a) {
      var e, i;
      const c = await o.chainEmployeeBindingPrecheck(r, l, a), t = (e = n == null ? void 0 : n.serverIndex) !== null && e !== void 0 ? e : 0, s = (i = B["ChainEmployeeBindingsApi.chainEmployeeBindingPrecheck"]) === null || i === void 0 || (i = i[t]) === null || i === void 0 ? void 0 : i.url;
      return (h, O) => v(c, u, m, n)(h, s || O);
    },
    async chainEmployeeBindingPrecheckBatch(r, l) {
      var a, e;
      const i = await o.chainEmployeeBindingPrecheckBatch(r, l), c = (a = n == null ? void 0 : n.serverIndex) !== null && a !== void 0 ? a : 0, t = (e = B["ChainEmployeeBindingsApi.chainEmployeeBindingPrecheckBatch"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (s, h) => v(i, u, m, n)(s, t || h);
    },
    async chainEmployeeBindingSave(r, l, a) {
      var e, i;
      const c = await o.chainEmployeeBindingSave(r, l, a), t = (e = n == null ? void 0 : n.serverIndex) !== null && e !== void 0 ? e : 0, s = (i = B["ChainEmployeeBindingsApi.chainEmployeeBindingSave"]) === null || i === void 0 || (i = i[t]) === null || i === void 0 ? void 0 : i.url;
      return (h, O) => v(c, u, m, n)(h, s || O);
    }
  };
}, U = function(n, o, r) {
  const l = p(n);
  return {
    chainEmployeeBindingDetail(a, e) {
      return l.chainEmployeeBindingDetail(a.corpUserId, e).then((i) => i(r, o));
    },
    chainEmployeeBindingExecuteBatch(a, e) {
      return l.chainEmployeeBindingExecuteBatch(a.chainEmployeeBatchActionCommand, e).then((i) => i(r, o));
    },
    chainEmployeeBindingPage(a, e) {
      return l.chainEmployeeBindingPage(a.query, e).then((i) => i(r, o));
    },
    chainEmployeeBindingPrecheck(a, e) {
      return l.chainEmployeeBindingPrecheck(a.corpUserId, a.chainEmployeeBindingSaveCommand, e).then((i) => i(r, o));
    },
    chainEmployeeBindingPrecheckBatch(a, e) {
      return l.chainEmployeeBindingPrecheckBatch(a.chainEmployeeBatchActionCommand, e).then((i) => i(r, o));
    },
    chainEmployeeBindingSave(a, e) {
      return l.chainEmployeeBindingSave(a.corpUserId, a.chainEmployeeBindingSaveCommand, e).then((i) => i(r, o));
    }
  };
}, b = class extends V {
  chainEmployeeBindingDetail(n, o) {
    return p(this.configuration).chainEmployeeBindingDetail(n.corpUserId, o).then((r) => r(this.axios, this.basePath));
  }
  chainEmployeeBindingExecuteBatch(n, o) {
    return p(this.configuration).chainEmployeeBindingExecuteBatch(n.chainEmployeeBatchActionCommand, o).then((r) => r(this.axios, this.basePath));
  }
  chainEmployeeBindingPage(n, o) {
    return p(this.configuration).chainEmployeeBindingPage(n.query, o).then((r) => r(this.axios, this.basePath));
  }
  chainEmployeeBindingPrecheck(n, o) {
    return p(this.configuration).chainEmployeeBindingPrecheck(n.corpUserId, n.chainEmployeeBindingSaveCommand, o).then((r) => r(this.axios, this.basePath));
  }
  chainEmployeeBindingPrecheckBatch(n, o) {
    return p(this.configuration).chainEmployeeBindingPrecheckBatch(n.chainEmployeeBatchActionCommand, o).then((r) => r(this.axios, this.basePath));
  }
  chainEmployeeBindingSave(n, o) {
    return p(this.configuration).chainEmployeeBindingSave(n.corpUserId, n.chainEmployeeBindingSaveCommand, o).then((r) => r(this.axios, this.basePath));
  }
};
export {
  b as ChainEmployeeBindingsApi,
  S as ChainEmployeeBindingsApiAxiosParamCreator,
  U as ChainEmployeeBindingsApiFactory,
  p as ChainEmployeeBindingsApiFp
};

//# sourceMappingURL=chain-employee-bindings-api.js.map